import classnames from 'classnames';
import { FC, RefAttributes, SVGProps } from 'react';

import styles from './illustration.module.scss';
import { IllustrationProps, IllustrationType } from './illustration.types';

export const Illustration =
  (
    IllustrationElement: FC<SVGProps<SVGSVGElement> & RefAttributes<SVGSVGElement>>
  ): IllustrationType =>
  ({ className, ...props }: IllustrationProps) => {
    return (
      <IllustrationElement className={classnames(styles.illustration, className)} {...props} />
    );
  };
